export default "__VITE_ASSET__B6c_dGjh__"